<template>
  <div class="detail about-page">
    <div class="detail-banner">
      <div class="container">
        <h1>关于我们</h1>
        <div class="sub">政经事 Roadlink GLB · 助力企业稳健出海</div>
      </div>
    </div>

    <div class="detail-body">
      <div class="container">
        <span class="detail-back" @click="$goBack()">‹ 返回</span>

        <div class="detail-content">
          <!-- 平台简介 -->
          <section class="about-block">
            <h3 class="block-title">平台简介</h3>
            <p>
              政经事（Roadlink
              GLB）平台(下称“政经事平台”)创立于2013年4月，总部位于深圳，是面向政府、企业和专业服务机构的市场化、数字化企业国际化综合服务平台。政经事平台主要承担数字平台建设、国别与行业研究、企业出海需求识别、专业服务资源组织、国际资源对接匹配及出海项目全过程管理等核心职能，将联盟汇聚的公共资源和专业资源转化为企业可获得、可跟进、可落地的标准化、定制化出海服务。2026年，成功入选广东省商务厅首批粤企出海服务资源库粤企出海线上服务平台板块，成为全省为数不多兼具数字化平台能力与线下专业服务网络体系的综合型国际化服务平台。
              自主研发“政经事小程序”数字化服务平台，以“企业出海测算”为服务入口，结合企业所属行业、目标市场、企业规模、出海目的、预算及既往经验，形成初步市场研判，并提供国别资讯、税收贸易投资指南、月度趋势报告、商务活动、专家机构、出海案例和专业服务对接等功能。政经事平台及其运营体系目前已链接130多个国家和地区的官方机构、产业园区、商协会及服务资源，汇聚1000余家金融、法律、财税、保险、知识产权、人力资源等专业机构，累计服务境内外企业超过7万家，已组织各类会议超过1000场，其中国际性论坛、经贸交流会议、境外展会等450场;搭建的国际科创路演平台，举办路演超过108场，累计为民营科技企业通过股权、债券融资超过3.7亿人民币。
            </p>
          </section>

          <!-- 核心数据 -->
          <section class="about-block">
            <h3 class="block-title">核心数据</h3>
            <div class="stat-grid">
              <div class="stat-card" v-for="(s, i) in stats" :key="i">
                <div class="stat-num">{{ s.num }}</div>
                <div class="stat-label">{{ s.label }}</div>
              </div>
            </div>
          </section>

          <!-- 核心服务 -->
          <section class="about-block">
            <h3 class="block-title">核心服务</h3>
            <div class="svc-grid">
              <div class="svc-card" v-for="(c, i) in services" :key="i">
                <div class="svc-icon">{{ c.icon }}</div>
                <h4>{{ c.title }}</h4>
                <p>{{ c.desc }}</p>
              </div>
            </div>
          </section>

          <!-- 联系我们 -->
          <section class="about-block">
            <h3 class="block-title">联系我们</h3>
            <ul class="contact-list">
              <li>
                <span class="c-icon">📍</span>
                <div>
                  <span class="c-label">公司地址</span>
                  <span class="c-value">深圳市福田区益田路江苏大厦A座1217</span>
                </div>
              </li>
              <li>
                <span class="c-icon">📞</span>
                <div>
                  <span class="c-label">联系电话</span>
                  <span class="c-value"
                    ><a href="tel:+8675583173363">+86 755-83173363</a></span
                  >
                </div>
              </li>
              <li>
                <span class="c-icon">✉️</span>
                <div>
                  <span class="c-label">电子邮箱</span>
                  <span class="c-value"
                    ><a href="mailto:zhengjingshi@roadlinkglb.com"
                      >zhengjingshi@roadlinkglb.com</a
                    ></span
                  >
                </div>
              </li>
            </ul>
          </section>

          <!-- 关注我们 -->
          <section class="about-block">
            <h3 class="block-title">关注我们</h3>
            <div class="follow-grid">
              <div class="follow-card" v-for="(f, i) in follows" :key="i">
                <img
                  class="follow-qr"
                  :src="f.qr"
                  :alt="f.name"
                  @error="onImgError"
                />
                <div class="follow-name">{{ f.name }}</div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  data() {
    return {
      stats: [
        { num: "170+", label: "国家/地区 全球网络资源" },
        { num: "70000+", label: "企业专业服务" },
        { num: "13年", label: "国际服务落地经验" },
        { num: "10万+", label: "企业用户服务" },
        { num: "3000+", label: "深度合作会员" },
        { num: "37亿元", label: "累计帮助企业获得融资" },
      ],
      services: [
        {
          icon: "🌐",
          title: "全球网络资源",
          desc: "覆盖全球政商资源库（政府、园区、商会、协会），对接海外市场准入、政策动态及项目资源，帮助企业快速获得成熟的国际化生态。",
        },
        {
          icon: "🛡️",
          title: "专业风险防控",
          desc: "基于 70000+ 企业案例数据库，提供风险防控、合规审查等成熟解决方案，国际经贸活动促成 1000+ 企业互动。",
        },
        {
          icon: "🤝",
          title: "全流程落地护航",
          desc: "由 1000+ 国际知名专业机构全流程护航，提供客户进入国际市场成交保障计划，沉淀 13 年服务落地经验。",
        },
      ],
      follows: [
        { name: "政经事公众号", qr: "/res/icon/code/zjsgongzhonghao.jpg" },
        { name: "政经事小程序", qr: "/res/icon/code/zjsminicode.jpg" },
        { name: "工业协会公众号", qr: "/res/icon/code/gongyezhizaoye.jpg" },
        {
          name: "走出去联盟公众号",
          qr: "/res/icon/code/lianmenggonzhonghao.jpg",
        },
      ],
    };
  },
  methods: {
    onImgError(e) {
      e.target.style.display = "none";
    },
  },
};
</script>

<style scoped>
.about-page .detail-content {
  display: block;
}

.about-block {
  padding: 4px 0 22px;
  margin-bottom: 22px;
}

.about-block:last-child {
  margin-bottom: 0;
}

.block-title {
  font-size: 19px;
  font-weight: 800;
  color: var(--text-main);
  position: relative;
  padding-left: 14px;
  margin-bottom: 18px;
}

.block-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 3px;
  bottom: 3px;
  width: 5px;
  border-radius: 3px;
  background: linear-gradient(180deg, var(--primary-light), var(--primary));
}

.about-block p {
  margin: 0;
  line-height: 1.95;
  font-size: 15px;
  color: var(--text-sub);
}

/* 核心数据 */
.stat-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.stat-card {
  background: linear-gradient(135deg, var(--blue-soft-2), #fff);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 22px 16px;
  text-align: center;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.stat-card:hover {
  transform: translateY(-4px);
  box-shadow: var(--shadow-hover);
}

.stat-num {
  font-size: 30px;
  font-weight: 800;
  color: var(--primary);
  line-height: 1.2;
}

.stat-label {
  margin-top: 8px;
  font-size: 13.5px;
  color: var(--text-sub);
}

/* 核心服务 */
.svc-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
}

.svc-card {
  background: var(--blue-soft-2);
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 22px 20px;
}

.svc-icon {
  font-size: 30px;
  margin-bottom: 12px;
}

.svc-card h4 {
  font-size: 16px;
  font-weight: 700;
  color: var(--text-main);
  margin: 0 0 10px;
}

.svc-card p {
  font-size: 13.5px;
  line-height: 1.8;
  color: var(--text-sub);
  margin: 0;
}

/* 联系我们 */
.contact-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 16px;
}

.contact-list li {
  display: flex;
  align-items: center;
  gap: 14px;
}

.c-icon {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  border-radius: 12px;
  background: var(--blue-soft);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.contact-list .c-label {
  display: block;
  font-size: 13px;
  color: var(--text-sub);
  margin-bottom: 3px;
}

.contact-list .c-value {
  font-size: 15px;
  font-weight: 600;
  color: var(--text-main);
}

.contact-list .c-value a {
  color: var(--primary);
  text-decoration: none;
}

.contact-list .c-value a:hover {
  text-decoration: underline;
}

/* 关注我们 */
.follow-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
}

.follow-card {
  text-align: center;
}

.follow-qr {
  width: 120px;
  height: 120px;
  margin: 0 auto 10px;
  border-radius: 8px;
  object-fit: cover;
  display: block;
  background: #fff;
  border: 1px solid var(--border);
  padding: 6px;
}

.follow-name {
  font-size: 14px;
  font-weight: 600;
  color: var(--text-main);
}

@media (max-width: 900px) {
  .stat-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  .svc-grid {
    grid-template-columns: 1fr;
  }
  .follow-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 560px) {
  .about-block {
    padding: 20px 16px;
  }
  .stat-grid {
    grid-template-columns: 1fr;
  }
  .follow-grid {
    grid-template-columns: 1fr;
  }
  .stat-num {
    font-size: 26px;
  }
}
</style>
